import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { GetCompletedCoachmarksResponse } from "../../models/coachmarkers/coachmarkers.models";
import { CacheClientService, CacheLocation } from "@rightship-tech/common-ui/services/basic/client-caching.service";
import { UserClientService } from "../authentication/user-client.service";
import { EventAggregator } from "aurelia-event-aggregator";

@autoinject
export class CoachmarkClientService {

    private onCoachmarkTriggered = 'onCoachmarkTriggered';

    constructor(private requestClient: RequestClientService, private cacheClientService: CacheClientService, private userClientService: UserClientService,
        private eventAggregator: EventAggregator) {
        
    }

    public isCoachmarkCompleted(key: string) : Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.getCompletedCoachmarks().then(response => {
                resolve(response.coachmarkKeys?.filter(x => x == key).length > 0);
            }).catch(x => {
                reject(x);
            });
        });
    }

    public getCompletedCoachmarks(refresh: boolean = false): Promise<GetCompletedCoachmarksResponse> {

        const fetchUncachedCoachmarksPromise = new Promise<GetCompletedCoachmarksResponse>((resolve, reject) => {
            const request = {};
            this.requestClient.get<GetCompletedCoachmarksResponse>("coachmark", request).then(response => {
                this.cacheClientService.put('coachmarks_user_' + this.userClientService.currentUser.id, response);
                resolve(response);
            }, e => {
                reject(e);
            });
        });

        if (!refresh) {
            return new Promise<GetCompletedCoachmarksResponse>((resolve, reject) => {
                this.cacheClientService.get<GetCompletedCoachmarksResponse>('coachmarks_user_' + this.userClientService.currentUser.id).then(response => {
                    if (response) { 
                        resolve(response);
                    }
                    else {
                        return fetchUncachedCoachmarksPromise.then(x => resolve(x), x => reject(x));
                    }
                }).catch(e => {
                    if (e == null) {
                        return fetchUncachedCoachmarksPromise.then(x => resolve(x), x => reject(x));
                    }
                    else reject(e);
                });
            });
        }
        else {
            return fetchUncachedCoachmarksPromise;
        }
    }

    public setCoachmarkCompleteRequest(key: string): Promise<void> {
        return new Promise<void>((resolve, reject) => { 
            const request = {
                key: key
            };        
            this.requestClient.post<void>("coachmark", {}, request).then(() => {
                this.getCompletedCoachmarks(true);
                resolve();
            }, e => {
                reject(e);
            });
        });
    }

    public resetMyCoachmarks() : Promise<void> {
        return new Promise<void>((resolve, reject) => {               
            this.requestClient.get<void>("coachmark/ResetMyCoachmarks", {}).then(() => {
                this.getCompletedCoachmarks(true);
                resolve();
            }, e => {
                reject(e);
            });
        });
    }

    public start(group: string) {
        setTimeout(() => {
            this.eventAggregator.publish(this.onCoachmarkTriggered, `${group}_1`);
            this.cacheClientService.put<string>('coachmark-group', group, CacheLocation.SessionStorage);
        });
    }

    public getFileFromPath(path: string) : string {        
        const pathBreaks = path.split('/');
        return pathBreaks[pathBreaks.length-1]
    }
}
